import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "control__box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "control__icon-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "control__icon iconfont icontrol-listen" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "control__icon-box" }

import { onMounted } from 'vue'

import { DocView } from '@/models/doc'
import { emitter } from '@/services/mitt'
import SidebarFavorite from '@/app/components/doc/reading/SidebarFavorite.vue'
import SidebarSettings from '@/app/components/doc/reading/SidebarSettings.vue'
import { DESKTOP_WIDTH } from '@/init/settings'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    doc: null,
    showTextControls: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { doc: DocView, showTextControls: boolean };



onMounted(async () => {
  // The 'docContentClicked' is emitted in @/app/components/doc/reading/Content.vue and
  // @/app/components/article/Content.vue
  emitter.on('docContentClicked', (event: any) => {
    props.doc.controls.onDocContentClicked(event)
  })
  emitter.on('showBookControlBar', () => {
    props.doc.controls.show()
  })
  emitter.on('windowResize', () => {
    props.doc.controls.onWindowResize()
  })
  emitter.on('toggleNightMode', async () => {
    props.doc.controls.onToggleNightMode()
  })
  // The 'docContentSelectionStarted' is emitted in @/app/components/doc/reading/Annotator.vue
  emitter.on('docContentSelectionStarted', () => {
    // Don't hide controls on desktop screens
    if (window.innerWidth >= DESKTOP_WIDTH) {
      return
    }

    props.doc.controls.hide()
  })
})

function togglePlayer(event: Event): void {
  props.doc.controls.togglePlayer(event)
  Mixpanel.trackSidebarItemClick('Player')
}

async function toggleNightMode(): Promise<void> {
  await props.doc.controls.toggleNightMode()
  Mixpanel.trackSidebarItemClick('Night Mode')
}

return (_ctx: any,_cache: any) => {
  return (__props.doc)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([__props.doc.controls.bookSidebarClass, "control"]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.showTextControls)
            ? (_openBlock(), _createBlock(SidebarSettings, {
                key: 0,
                class: _normalizeClass(__props.doc.controls.fontsBtnClass),
                doc: __props.doc
              }, null, 8, ["class", "doc"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default"),
          (__props.showTextControls && __props.doc.has_audio)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([__props.doc.controls.playerBtnClass, "control__btn player-btn"]),
                title: "Listen",
                onClick: togglePlayer
              }, _hoisted_3, 2))
            : _createCommentVNode("", true),
          _createVNode(SidebarFavorite, {
            doc: __props.doc,
            class: _normalizeClass(__props.doc.controls.favoriteBtnClass)
          }, null, 8, ["doc", "class"]),
          _createElementVNode("div", {
            class: _normalizeClass([__props.doc.controls.nightModeBtnClass, "control__btn night-btn"]),
            title: "Night mode",
            onClick: toggleNightMode
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: _normalizeClass(__props.doc.controls.nightModeIconClass)
              }, null, 2)
            ])
          ], 2),
          _renderSlot(_ctx.$slots, "tutorial")
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})